import { useTranslation } from "react-i18next";

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative min-h-[600px] md:min-h-[720px] flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20vibrant%20ecommerce%20lifestyle%20collage%20of%20fashion%20products%20including%20sneakers%20hoodies%20jackets%20bags%20and%20perfume%20bottles%20artfully%20arranged%20on%20a%20soft%20warm%20gradient%20backdrop%20with%20subtle%20pastel%20cream%20and%20sage%20tones%2C%20dreamy%20editorial%20style%2C%20soft%20natural%20light%2C%20high%20end%20shopping%20aesthetic%2C%20clean%20spacious%20composition%20with%20copy%20space%20in%20the%20center&width=1600&height=900&seq=hero-main&orientation=landscape&nocache=true"
          alt="CSSBuy Spreadsheet Fashion Collection"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/40" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full py-20 md:py-28">
        <div className="max-w-3xl">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
            {t("home.hero.h1")}
          </h1>
          <p className="text-lg md:text-xl text-white/90 leading-relaxed mb-8 max-w-2xl">
            {t("home.hero.subtitle")}
          </p>

          <div className="flex flex-col sm:flex-row gap-4 mb-8">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-white text-gray-900 font-semibold rounded-lg hover:bg-gray-100 transition-colors whitespace-nowrap"
            >
              <i className="ri-external-link-line" />
              CSSBuy Spreadsheet
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-emerald-700 text-white font-semibold rounded-lg hover:bg-emerald-800 transition-colors whitespace-nowrap"
            >
              <i className="ri-shopping-bag-line" />
              {t("home.hero.cta2")}
            </a>
          </div>

          <div className="flex items-center gap-4 text-sm text-white/80">
            <span className="flex items-center gap-1">
              <i className="ri-check-line text-emerald-400" />
              {t("home.hero.trust")}
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}